import { lazy } from 'react';

export const PharmacistsControlPage = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "PharmacistsControlPagePage" */
      './PharmacistsControlPage'
    ),
);
